function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M.5 4.444A3.704 3.704 0 0 1 4.204.741h51.852a3.704 3.704 0 0 1 3.703 3.703v31.111a3.704 3.704 0 0 1-3.703 3.704H4.204A3.704 3.704 0 0 1 .5 35.556V4.444z",
  fill: "#A0AAAF"
});

var _ref3 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.603 7.056c.55 0 1.054.182 1.456.487l.377-.396a2.962 2.962 0 0 0-1.833-.628c-1.612 0-2.918 1.265-2.918 2.826 0 1.561 1.306 2.827 2.918 2.827.694 0 1.332-.236 1.833-.628l-.391-.387c-.4.299-.9.478-1.442.478-1.305 0-2.364-1.025-2.364-2.29 0-1.264 1.059-2.29 2.364-2.29zm26.004 3.11-3.106-3.582h-1.142v5.495h1.24v-3.58l3.058 3.58h1.187V6.584h-1.237v3.582zm3.145.906V9.73h1.565v-.986h-1.566V7.57h2.706v-.987h-3.871V12.1h3.929v-1.028H37.75zM20.81 9.102c.578.21.99.751.99 1.384v.13c0 .814-.683 1.477-1.524 1.477h-1.83V6.6h1.246c.84 0 1.524.662 1.524 1.476V8.1c0 .387-.154.74-.406 1.003zm-1.78-.093h.662c.518 0 .939-.408.939-.91v-.023c0-.501-.421-.91-.939-.91h-.661V9.01zm2.185 1.477c0-.502-.42-.91-.939-.91h-1.245v1.95h1.245c.518 0 .94-.409.94-.91v-.13zm-3.951-.216c0 .752-.605 1.364-1.349 1.364h-.033a1.358 1.358 0 0 1-1.348-1.364V6.606h-.586v3.664c0 1.065.868 1.932 1.934 1.932h.033a1.935 1.935 0 0 0 1.934-1.932V6.606h-.585v3.664zM11.56 6.606h-.586v5.473h2.816v-.601h-2.23V6.606zm15.283-.087c1.612 0 2.918 1.265 2.918 2.826 0 1.561-1.306 2.827-2.918 2.827-1.611 0-2.918-1.266-2.918-2.827 0-1.56 1.307-2.826 2.918-2.826zm0 4.549c.998 0 1.807-.784 1.807-1.751 0-.967-.809-1.75-1.807-1.75-.997 0-1.806.783-1.806 1.75s.809 1.75 1.806 1.75z",
  fill: "#fff"
});

var _ref4 = React.createElement("path", {
  d: "M57.352.985a3.686 3.686 0 0 1 2.408 3.46v15.4H43.974c0-8.69 5.578-16.082 13.378-18.86zM56.056 39.26c.607 0 1.178-.163 1.681-.422-8-2.667-13.763-10.156-13.763-18.985 0 9.348-6.459 17.2-15.192 19.407h27.274z",
  fill: "#EEF1F1"
});

var SvgClubOneCardDisabled = function SvgClubOneCardDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 53,
    height: 40,
    viewBox: "0 0 53 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClubOneCardDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/club-one-card-disabled.d737bbf2.svg";
export { ForwardRef as ReactComponent };